



































































































































































import Vue from "vue";
import { Component, Watch } from "vue-property-decorator";
import {
  FactFindAssetDto,
  CreateAssetCommand,
  AssetTypeDto,
  OwnerDto,
  YesNoDefaultDto,
  AssetClassificationDto,
  TimeframeDto,
  UpdateAssetCommand,
  ClientSelector
} from "@/api/ClientPortalApiClient";
import ApiFactory from "@/api/ApiFactory";
import CbxAssetType from "@/views/lookups/CbxAssetType.vue";
import CbxYesNoDefault from "@/views/lookups/CbxYesNoDefault.vue";
import CbxTimeFrame from "@/views/lookups/CbxTimeFrame.vue";
import CbxAssetClassification from "@/views/lookups/CbxAssetClassification.vue";
import { UserStore, LoadingSpinnerService } from "@/store";
import CbxOwner from "@/views/lookups/CbxOwner.vue";
import CbxBaseAssets from "./CbxBaseAssets.vue";
import AlertService from "@/services/alert.service";

@Component({
  components: {
    CbxOwner,
    CbxAssetType,
    CbxYesNoDefault,
    CbxTimeFrame,
    CbxAssetClassification
  }
})
export default class FactFindAssets extends Vue {
  private emptyAsset = new FactFindAssetDto();
  private selectAsset = new FactFindAssetDto();
  private contactId: number = 0;
  private modelSig = "";
  private hasUnsavedChanges = false;
  private displayModel = new FactFindAssetDto();
  private assets: FactFindAssetDto[] = [];
  private formEnabled: boolean = false;
  private mode: string = "default";
  private alertService = new AlertService();
  private clientNames: OwnerDto[] = [];

  $refs!: {
    owner: CbxOwner;
    assetTypes: CbxAssetType;
    timeframes: CbxTimeFrame;
    isFamilyHome: CbxYesNoDefault;
    canBeSold: CbxYesNoDefault;
    mainForm: HTMLFormElement;
  };

  async created() {
    this.contactId = parseInt(this.$route.params.contactId);
    this.getAssets(true);
    await this.getClientSelectorNames();
  }

  private async getClientSelectorNames() {
    const api = ApiFactory.CreateDataClient();
    const data = await api.owner_Index(this.contactId);
    this.clientNames = data || [];
  }

  private assetDisplayName(asset: FactFindAssetDto): string {
    const owner = this.clientNames.find(x => x.id === asset.owner);
    return (
      (owner ? owner.name : "") + " - " + (asset.type ? asset.type.name : "")
    );
  }

  private saveAsset(e: Event) {
    e.preventDefault();
    if (this.mode === "update") {
      this.update();
    } else if (this.mode === "create") {
      this.createNew();
    }
  }

  public async saveChanges(): Promise<boolean> {
    if (this.$refs.mainForm.checkValidity()) {
      if (this.mode === "update") {
        return await this.update();
      } else if (this.mode === "create") {
        return await this.createNew();
      }

      return true;
    }

    this.alertService.error(
      "Form Validation Failed",
      "Please complete all required fields"
    );
    return false;
  }

  public async createNew(): Promise<boolean> {
    LoadingSpinnerService.Show("Saving new asset...");
    const api = ApiFactory.CreateDataClient();
    let cmd = new CreateAssetCommand();

    cmd.owner = this.displayModel.owner;
    cmd.contactId = this.displayModel.contactId || this.contactId;
    cmd.otherType = this.displayModel.otherType;
    cmd.approximateValue = this.displayModel.approximateValue;
    cmd.location = this.displayModel.location;
    cmd.annualGrowthDecline = this.displayModel.annualGrowthDecline;
    cmd.notes = this.displayModel.notes;
    if (this.displayModel.isFamilyHome) {
      cmd.isFamilyHomeId = this.displayModel.isFamilyHome.id;
    }
    if (this.displayModel.type) {
      cmd.typeId = this.displayModel.type.id;
    }
    if (this.displayModel.canBeSold) {
      cmd.canBeSoldId = this.displayModel.canBeSold.id;
    }
    if (this.displayModel.approximateTimeframe) {
      cmd.approximateTimeframeId = this.displayModel.approximateTimeframe.id;
    }

    try {
      const result = await api.factFindAsset_IndexPOST(cmd);
      this.displayModel.id = result;
      await this.getAssets();
      this.assets.find(x => x.id === result) || this.displayModel;
      this.displayModel =
        this.assets.find(x => x.id === result) || this.displayModel;
      this.mode = "update";

      this.modelSig = this.displayModel.toJSON();
      LoadingSpinnerService.Success("New asset saved successfully");
      return true;
    } catch (e) {
      LoadingSpinnerService.Failure("Could not save asset, please try again");
    }

    return false;
  }

  public async update(): Promise<boolean> {
    LoadingSpinnerService.Show("Updating asset...");
    const api = ApiFactory.CreateDataClient();
    let cmd = new UpdateAssetCommand();
    cmd.id = this.displayModel.id;
    cmd.owner = this.displayModel.owner;
    cmd.contactId = this.displayModel.contactId;
    cmd.otherType = this.displayModel.otherType;
    cmd.approximateValue = this.displayModel.approximateValue;
    cmd.location = this.displayModel.location;
    cmd.annualGrowthDecline = this.displayModel.annualGrowthDecline;
    cmd.notes = this.displayModel.notes;
    if (this.displayModel.isFamilyHome) {
      cmd.isFamilyHomeId = this.displayModel.isFamilyHome.id;
    }
    if (this.displayModel.type) {
      cmd.typeId = this.displayModel.type.id;
    }
    if (this.displayModel.canBeSold) {
      cmd.canBeSoldId = this.displayModel.canBeSold.id;
    }
    if (this.displayModel.approximateTimeframe) {
      cmd.approximateTimeframeId = this.displayModel.approximateTimeframe.id;
    }

    try {
      var result = await api.factFindAsset_IndexPUT(cmd);
      if (result) {
        await this.getAssets();
        this.modelSig = JSON.stringify(this.displayModel.toJSON()).toString();
        LoadingSpinnerService.Success("Asset updated successfully");
        return true;
      } else {
        LoadingSpinnerService.Failure("Coud not save asset, please try again");
      }
    } catch (e) {
      LoadingSpinnerService.Failure("Could not save asset, please try again");
    }

    return false;
  }

  private async getAssets(showLoader: boolean | undefined = undefined) {
    if (showLoader) LoadingSpinnerService.Show("Loading assets...");
    const api = ApiFactory.CreateDataClient();

    try {
      const result = await api.factFindAsset_IndexAll(this.contactId);
      this.assets = result || [];
      if (showLoader) LoadingSpinnerService.Hide();
    } catch (e) {
      this.assets = [];
      LoadingSpinnerService.Failure("Could not load assets, please try again");
    }
  }

  private async rowSelected(item: FactFindAssetDto) {
    if (!(await this.checkForChanges())) {
      return;
    }

    this.formEnabled = true;
    this.mode = "update";
    this.displayModel = this.emptyAsset;
    this.displayModel = item;
    this.modelSig = JSON.stringify(this.displayModel.toJSON()).toString();
    // Update Selected Options
    if (this.displayModel.owner) {
      this.$refs.owner.setSelected(this.displayModel.owner);
    } else {
      this.$refs.owner.setSelected(ClientSelector.Main);
    }

    this.$refs.assetTypes.setSelected(this.displayModel.type);
    this.$refs.canBeSold.setSelected(this.displayModel.canBeSold);
    this.$refs.isFamilyHome.setSelected(this.displayModel.isFamilyHome);
    this.$refs.timeframes.setSelected(this.displayModel.approximateTimeframe);
  }

  private saveClicked() {
    this.formEnabled = false;
    this.clearData();
    this.mode = "default";
  }

  private createClicked() {
    this.clearData();
    this.mode = "create";
    this.formEnabled = true;
  }

  private clearData() {
    this.modelSig = JSON.stringify(this.emptyAsset.toJSON()).toString();
    this.displayModel = this.emptyAsset;
    this.displayModel.otherType = "";
    this.displayModel.notes = "";
    this.displayModel.location = "";
    this.displayModel.approximateValue = 0;
    this.$refs.assetTypes.setSelected(new AssetTypeDto());
    this.$refs.canBeSold.setSelected(new YesNoDefaultDto());
    this.$refs.isFamilyHome.setSelected(new YesNoDefaultDto());
    this.$refs.timeframes.setSelected(new TimeframeDto());
  }

  private ownerSelected(name: ClientSelector) {
    this.displayModel.owner = name;
  }
  private assetTypeSelected(type: AssetTypeDto) {
    this.displayModel.type = type;
  }
  private canBeSoldSelected(type: YesNoDefaultDto) {
    this.displayModel.canBeSold = type;
  }
  private isFamilyHomeSelected(type: YesNoDefaultDto) {
    this.displayModel.isFamilyHome = type;
  }
  private approxTimeframeSelected(type: TimeframeDto) {
    this.displayModel.approximateTimeframe = type;
  }

  public async checkForChanges(): Promise<boolean> {
    if (this.isDisplayModelEmpty() == false) {
      if (this.hasChanges() == true) {
        if (confirm("Would you like to save your changes?")) {
          return await this.saveChanges();
        }
      }
    }

    return true;
  }

  private isDisplayModelEmpty(): boolean {
    return (
      this.mode !== "create" &&
      JSON.stringify(this.displayModel.toJSON()) ===
        JSON.stringify(this.emptyAsset.toJSON())
    );
  }

  private hasChanges(): boolean {
    const s1 = JSON.stringify(this.displayModel.toJSON()).toString();
    if (s1 !== this.modelSig) {
      return true;
    } else {
      return false;
    }
  }
}
